import React from "react";
import AdminSales from "../../components/admin/components/AdminSales";

const Sales = () => {
  return <AdminSales />;
};

export default Sales;
